export default "__VITE_ASSET__67758fb2__"